import React from 'react';

const Facebook = () => (
  <svg viewBox="0 0 20 20" fill="currentColor">
    <path d="M11,8h3v3H11v7H8V11H5L5,8h6Z" />
    <path d="M14,8H11V6a1,1,0,0,1,1-1h2V2H12A4,4,0,0,0,8,6v5h6Z" />
  </svg>
);
export default Facebook;
